import React from 'react'


export default function LoadingAnimation({ loadingText = null }) {
  return (
    <center>
      <img alt="loader" src={require("../static/images/spinner.gif")} />
      { loadingText && <h4>loadingText</h4> }
    </center>
  )
}


// WEBPACK FOOTER //
// ./src/reuseable-components/LoadingAnimation.js